import { render, staticRenderFns } from "./LeaderboardTable.vue?vue&type=template&id=f58a25b6&scoped=true"
import script from "./LeaderboardTable.vue?vue&type=script&lang=ts"
export * from "./LeaderboardTable.vue?vue&type=script&lang=ts"
import style0 from "./LeaderboardTable.vue?vue&type=style&index=0&id=f58a25b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58a25b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f58a25b6')) {
      api.createRecord('f58a25b6', component.options)
    } else {
      api.reload('f58a25b6', component.options)
    }
    module.hot.accept("./LeaderboardTable.vue?vue&type=template&id=f58a25b6&scoped=true", function () {
      api.rerender('f58a25b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/LeaderboardTable.vue"
export default component.exports